import { NAME } from './constants';
import { router } from './router';

export const WmsServiceAdvisor = {
	name: NAME,
	router,
};
